var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var baseCls = "rj-yourbet__btn";
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var mdfr = this.props.modifier ? " " + baseCls + "--" + this.props.modifier : "";
        var dataUat = this.props.modifier ? "-" + this.props.modifier : "";
        return (React.createElement("button", { className: "" + baseCls + mdfr, "data-uat": "your-bet-btn" + dataUat, onClick: this.props.handler, disabled: this.props.disabled },
            React.createElement("span", { className: baseCls + "-inner", "data-uat": "your-bet-btn-name" }, this.props.children)));
    };
    return Button;
}(React.Component));
export { Button };
//# sourceMappingURL=Button.js.map